import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { handleFormChange } from '@/src/updateProfile/redux/actions';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
  selectContainer: (bool = false) => css`
    width: 100%;
    margin: 1.6rem 0;
    display: ${bool ? 'none' : 'block'};
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.white};
      border: 1px solid ${colors.accentGrayMedium};
    }
  `,
};

const MailingState = props => {
  const { form, info, updateProfile, key, onChange } = props;
  const { options = [], optionId, optionDesc, isMailing } = info;
  const { isOtherMailingStateVisible, isMailingAddressDisabled } = updateProfile;
  const isFieldVisible = Boolean(isMailing) && isMailingAddressDisabled;

  const stateChange = e => {
    if (e === 'Other') {
      props.handleFormChange('isOtherMailingStateVisible', true);
    } else {
      props.handleFormChange('isOtherMailingStateVisible', false);
    }
  };

  useEffect(() => {
    if (updateProfile.PoBoxStateCode === 'Other') {
      props.handleFormChange('isOtherMailingStateVisible', true);
    }
  }, []);

  return (
    <>
      <div key={optionId} css={styles.selectContainer(isFieldVisible)}>
        <Form.Item label="State">
          {form.getFieldDecorator('PoBoxStateCode', {
            initialValue: updateProfile['PoBoxStateCode'],
            rules: [{ required: !isMailingAddressDisabled, message: 'Select State.' }],
          })(
            <Select
              disabled={isMailing && isMailingAddressDisabled}
              showSearch
              allowClear
              onChange={e => {
                stateChange(e);
                onChange('PoBoxStateCode', e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
              optionFilterProp="children"
            >
              {options.map(option => (
                <Option key={`PoBoxStateCode-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherMailingStateVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="State/Region/Province">
            {form.getFieldDecorator('PoBoxOther', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter State/Region/Province.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('PoBoxOther', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

export default connect(
  mapStateToProps,
  { handleFormChange }
)(MailingState);
